import { Component, Inject, OnInit } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { NotificationService } from '../../../../../notification/shared/notification.service'
import { CommandeParamSettingsService } from '../shared/commande-param-settings.service'
import { MatSelectionListChange } from '@angular/material/list'

@Component({
  selector: 'app-statistics-modal',
  templateUrl: './statistics-modal.component.html',
  styleUrls: [
    './statistics-modal.component.scss'
  ]
})
export class StatisticsModalComponent implements OnInit {
  commandeSettingsService: CommandeParamSettingsService
  notificationService: NotificationService

  constructor(
    public dialogRef: MatDialogRef<StatisticsModalComponent>,
    commandeSettingsService: CommandeParamSettingsService,
    notificationService: NotificationService,
    @Inject(MAT_DIALOG_DATA) public data,
  ) {
    this.commandeSettingsService = commandeSettingsService
    this.notificationService = notificationService
    this.data = this.data.filter(el => el.article.famille.cle_ref != '112')
  }

  ngOnInit(): void {
  }

  onSubmit() {
    let statistics = this.data.map(el => {
      let obj = { id: el.id, enabled_statistics: el.enabled_statistics }
      return obj
    })

    this.commandeSettingsService.patchCommandeSettingsStatistics(statistics).subscribe(
      data => {
        this.notificationService.notif("Le paramétrage des statistiques a été mis à jour", "notif")
        this.dialogRef.close(this.data)
      }
    )
  }

  refuse() {
    this.dialogRef.close(false)
  }

  selectionChange($event: MatSelectionListChange) {
    $event.options.forEach(option => {
      const article = this.data.find(a => a.id === option.value);
      if (article) {
        article.enabled_statistics = option.selected;
      }
    });
  }
}